module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Войти")]), _vm._v(" "), (_vm.canSignUp) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/sign-up"
    }
  }, [_c('span', [_vm._v("Зарегистрироваться")])]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5075c840"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/authentication/Login.vue
// module id = 293
// module chunks = 42